<template>
	<div class="skill-item tw-p-4 custom-fade-in">
		<div class="tw-flex tw-justify-between tw-items-center tw-gap-4 tw-pb-3">
			<span class="text-lg"
				><b>{{ factorI.name }}</b> ({{ factorI.score }})</span
			>
			<div class="tw-flex tw-gap-4 tw-items-center">
				<edit-icon class="cursor-pointer" @click="$emit('editClicked')"></edit-icon>
				<trash-icon-new 
					v-if="validateBtnDelete"
					:color="`${$appColors.secondary}`"
					class="cursor-pointer"
					@click="$emit('closeClicked')">
				</trash-icon-new>
			</div>
		</div>
		<p-horizontal-divider mx="-1rem" my="0" />
		<section class="tw-flex tw-flex-col">
			<subfactor-sortable-list
				style="margin: 0 -20px;"
				:sub-factor="factorI.subFactors || []"
				@removeClicked="handleRemoveSubFactor($event, factorI)"
				@editClicked="handleEditSubFactor($event, factorI)"
				@onSortedSubFactorsChange="handleSortedSubFactor($event, factorI)">
			</subfactor-sortable-list>
			<div class="tw-flex tw-justify-center tw-mt-3">
				<p-button
					type="primary"
					rounded-level="rounded"
					size="small"
					@click="handlerAddSubFactor(factorI)">Añadir Subfactor
				</p-button>
			</div>
		</section>
		<add-subfactor-dialog
			ref="actionSubFactor"
			:selected-sub-factor="selectedSubFactor"
			:flagEditItem="flagEditItem"
			@handlerItem="handlerItem($event, factorI)"
		></add-subfactor-dialog>
	</div>
</template>

<script>
import { assoc, has, path, propOr, clone } from 'ramda';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import TrashIconNew from '@/modules/shared/components/icons/trash-icon-new';
import EditIcon from '@/modules/shared/components/icons/edit-icon';
import QuestionTypeSelector from '@/modules/three-sixty-evaluation/components/third-step/components/question-type-selector';
import EvaluationQuestionSortableList from '@/modules/three-sixty-evaluation/components/third-step/components/evaluation-question-sortable-list';
import addSubfactorDialog from '@/modules/recruitment/components/content/add-subfactor-dialog';
import subfactorSortableList from '@/modules/recruitment/components/content/subfactor-sortable-list';
import { removeItemList } from '@/modules/recruitment/utils/listElements';

export default {
	name: 'factor-items',
	props: ['factorI'],
	data() {
		return {
			focusedFactor: [],
			selectedSubFactor: {},
			flagEditItem: false,
		};
	},
	components: {
		TrashIconNew,
		EditIcon,
		PButton,
		PHorizontalDivider,
		QuestionTypeSelector,
		EvaluationQuestionSortableList,
		subfactorSortableList,
		addSubfactorDialog,
	},
	methods: {
		propOr,
		path,
		has,
		handlerAddSubFactor(factor) {
			this.selectedSubFactor = {};
			this.flagEditItem = false;
			this.focusedFactor = factor;
			this.$refs.actionSubFactor.open();
		},
		handlerItem(subfactor, factor) {
			this.flagEditItem = false;
			const newItem = clone(subfactor);
			this.focusedFactor = factor;
			let newCode;
			do {
				newCode = this.generateUniqueCode(4);
			} while (this.codeExist(newCode, this.focusedFactor.subFactors));
			newItem.code = newCode;
			if (this.focusedFactor.name !== 'ENTREVISTA') {
				delete newItem.questions;
				delete newItem.equivalences;
			}
			this.focusedFactor.subFactors.push(
				newItem,
			);
		},
		generateUniqueCode(length) {
			let result = '';
			const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			const charactersLength = characters.length;
			for (let i = 0; i < length; i += 1) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		},
		codeExist(code, arrayObjects) {
			return arrayObjects.some(obj => obj.code === code);
		},
		handleRemoveSubFactor(selectSubFactor, factor) {
			this.focusedFactor = factor;
			const updateSubFactors = removeItemList(
				selectSubFactor,
				factor.subFactors,
			);
			const updateFactor = assoc('subFactors', updateSubFactors, this.focusedFactor);
			this.$emit('updateFactorItem', updateFactor);
		},
		handleEditSubFactor(selectSubFactor, factor) {
			this.focusedFactor = factor;
			this.selectedSubFactor = selectSubFactor;
			this.flagEditItem = true;
			this.$refs.actionSubFactor.open();
		},
		handleSortedSubFactor(selectSubFactor, factor) {
			this.focusedFactor = factor;
			const updateFactor = assoc('subFactors', selectSubFactor, this.focusedFactor);
			this.$emit('updateFactorItem', updateFactor);
		},
	},
	computed: {
		validateBtnDelete() {
			const noFlagsPresentes = !has('flagInput', this.factorI) && !has('flagInterview', this.factorI);
			return noFlagsPresentes;
		},
	},
};
</script>

<style lang="scss">
.skill-item {
	border: 1px solid var(--app-color-gray);
	border-radius: 10px;
	span {
		color: map-get($colors, gray-sidebar);
		font-size: 16px !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/recruitment/components/content/factor-items.vue